export default __webpack_public_path__ + "static/media/notificationbell.d838ba1b.svg";